export default __webpack_public_path__ + "static/media/etherscan-logo-circle.c49ca24b.svg";